import { Box, Container, Grid, Typography } from "@mui/material"
import ProjectCard from "./ProjectCard";

const Project = () => {
  return(
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: '#efe1bd',
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{ mb: 7 }}
            variant="h4"
            align="center"
            letterSpacing= '6px' 
            textTransform= 'uppercase'
          >
            Project
          </Typography>
          <Grid
            container
            // spacing={3}
            // align="center"
          >
            <Grid
              item
              lg={12}
              md={12}
              xs={12}
              sx={{ marginLeft: '33%'}}
            >
                <ProjectCard />

            </Grid>
            {/* <Grid
              item
              lg={6}
              md={6}
              xs={12}
            >
              <ProjectCard />
            </Grid> */}
          </Grid>
        </Container>
      </Box>
    </>
  )
}

export default Project